import { Spacer } from "@chakra-ui/react";

interface GenericSpacerProps {
  variant?: "standard" | "double" | "triple" | "heroIntro";
}

export default function GenericSpacer({
  variant = "standard",
}: GenericSpacerProps) {
  let heightValue: { base: string; md: string };
  switch (variant) {
    case "triple":
      heightValue = { base: "24", md: "36" };
      break;
    case "heroIntro":
      heightValue = { base: "12", md: "12" };
      break;
    case "double":
      heightValue = { base: "16", md: "24" };
      break;
    case "standard":
    default:
      heightValue = { base: "8", md: "12" };
      break;
  }

  return <Spacer h={heightValue} />;
}
